import React, { FC, ReactElement, ReactNode } from 'react'
import classNames from 'classnames';
import ReactPlaceholder from 'react-placeholder/lib';

interface PlaceholderProps {
  loadingDone: boolean;
  custom?: any;
  type?: 'text' | 'media';
  rows?: number;
  className?: string;
}

export const Placeholder: FC<PlaceholderProps> = (props) => {
  const { loadingDone, custom, className, children, rows = 2, type = 'text' } = props;

  if (custom) {
    return (
      <ReactPlaceholder
        showLoadingAnimation
        ready={loadingDone}
        className={classNames('show-loading-animation', className)}
        customPlaceholder={custom()}
      >
        {children}
      </ReactPlaceholder>
    )
  }
  return (
    <ReactPlaceholder
      showLoadingAnimation
      type={type}
      rows={rows}
      ready={loadingDone}
      className={classNames('show-loading-animation', className)}
    >
      {children}
    </ReactPlaceholder>
  )
};

